/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useState, state, forwardRef, useImperativeHandle } from "react";
import toast from "react-hot-toast";

import Button from "@mui/material/Button";

const DatosAdicionales1 = forwardRef(
  ({ Back, Next, props, vista = "registrar", desactivar }, ref) => {
    // Estados para los campos
    const [AplicadoOtroPrograma, setAplicadoOtroPrograma] = useState(
      props?.aplicadoOtroPrograma ?? null
    );
    const [AplicadoOtroProgramaCual, setAplicadoOtroProgramaCual] = useState(
      props?.aplicadoOtroProgramaCual ? props.aplicadoOtroProgramaCual : ""
    );

    // Estados para validación
    const [isvalid_AplicadoOtroPrograma, isvalid_setAplicadoOtroPrograma] = useState(false);
    const [isvalid_AplicadoOtroProgramaCual, isvalid_setAplicadoOtroProgramaCual] = useState(false);

    // Estados para los campos
    const [RechazadoPrograma, setRechazadoPrograma] = useState(props?.rechazadoPrograma ?? null);
    const [RechazadoProgramaCual, setRechazadoProgramaCual] = useState(
      props?.rechazadoProgramaCual ? props.rechazadoProgramaCual : ""
    );
    const [EvalOtroEspecialista, setEvalOtroEspecialista] = useState(
      props?.evalOtroEspecialista ?? null
    );
    const [EvalOtroEspecialistaCual, setEvalOtroEspecialistaCual] = useState(
      props?.evalOtroEspecialistaCual ? props.evalOtroEspecialistaCual : ""
    );
    const [EvaluadoOdontologia, setEvaluadoOdontologia] = useState(
      props?.evaluadoOdontologia ?? null
    );
    const [EvaluadoOdontologiaDr, setEvaluadoOdontologiaDr] = useState(
      props?.evaluadoOdontologiaDr ? props.evaluadoOdontologiaDr : ""
    );
    const [ServicioInternet, setServicioInternet] = useState(props?.servicioInternet ?? null);
    const [ServicioInternetCual, setServicioInternetCual] = useState(
      props?.servicioInternetCual ? props.servicioInternetCual : ""
    );
    const [Computadora, setComputadora] = useState(props?.computadora ?? null);
    const [ComputadoraCual, setComputadoraCual] = useState(
      props?.computadoraCual ? props.computadoraCual : ""
    );
    const [PlataformaVideo, setPlataformaVideo] = useState(props?.plataformaVideo ?? null);
    const [PlataformaVideoCual, setPlataformaVideoCual] = useState(
      props?.plataformaVideoCual ? props.plataformaVideoCual : ""
    );

    // Estados para validación
    const [isvalid_RechazadoPrograma, isvalid_setRechazadoPrograma] = useState(false);
    const [isvalid_RechazadoProgramaCual, isvalid_setRechazadoProgramaCual] = useState(false);
    const [isvalid_EvalOtroEspecialista, isvalid_setEvalOtroEspecialista] = useState(false);
    const [isvalid_EvalOtroEspecialistaCual, isvalid_setEvalOtroEspecialistaCual] = useState(false);
    const [isvalid_EvaluadoOdontologia, isvalid_setEvaluadoOdontologia] = useState(false);
    const [isvalid_EvaluadoOdontologiaDr, isvalid_setEvaluadoOdontologiaDr] = useState(false);
    const [isvalid_ServicioInternet, isvalid_setServicioInternet] = useState(false);
    const [isvalid_ServicioInternetCual, isvalid_setServicioInternetCual] = useState(false);
    const [isvalid_Computadora, isvalid_setComputadora] = useState(false);
    const [isvalid_ComputadoraCual, isvalid_setComputadoraCual] = useState(false);
    const [isvalid_PlataformaVideo, isvalid_setPlataformaVideo] = useState(false);
    const [isvalid_PlataformaVideoCual, isvalid_setPlataformaVideoCual] = useState(false);

    const ValidaForm = () => {
      // Validación para el campo AplicadoOtroPrograma
      if (AplicadoOtroPrograma == null || AplicadoOtroPrograma == undefined) {
        toast.error(
          "¿Ha aplicado a algún otro programa de implantes cocleares?: Campo obligatorio *"
        );
        isvalid_setAplicadoOtroPrograma(true);
        return null;
      }
      if (AplicadoOtroPrograma == "1" && !AplicadoOtroProgramaCual) {
        toast.error("¿A cuál?: Campo obligatorio *");
        isvalid_setAplicadoOtroProgramaCual(true);
        return null;
      }

      // Validación para el campo RechazadoPrograma
      if (RechazadoPrograma == null || RechazadoPrograma == undefined) {
        toast.error(
          "¿Lo han rechazado de algún otro programa de implante coclear?: Campo obligatorio *"
        );
        isvalid_setRechazadoPrograma(true);
        return null;
      }
      if (RechazadoPrograma == "1" && !RechazadoProgramaCual) {
        toast.error("¿De cuál?: Campo obligatorio *");
        isvalid_setRechazadoProgramaCual(true);
        return null;
      }

      // Validación para el campo EvalOtroEspecialista
      if (EvalOtroEspecialista == null || EvalOtroEspecialista == undefined) {
        toast.error("¿Ha sido evaluado por algún otro especialista?: Campo obligatorio *");
        isvalid_setEvalOtroEspecialista(true);
        return null;
      }
      if (EvalOtroEspecialista == "1" && !EvalOtroEspecialistaCual) {
        toast.error("¿Cuál? ¿Motivo?: Campo obligatorio *");
        isvalid_setEvalOtroEspecialistaCual(true);
        return null;
      }

      // Validación para el campo EvaluadoOdontologia
      if (EvaluadoOdontologia == null || EvaluadoOdontologia == undefined) {
        toast.error("¿Ha sido evaluado por odontología?: Campo obligatorio *");
        isvalid_setEvaluadoOdontologia(true);
        return null;
      }
      if (EvaluadoOdontologia == "1" && !EvaluadoOdontologiaDr) {
        toast.error("Nombre del doctor: Campo obligatorio *");
        isvalid_setEvaluadoOdontologiaDr(true);
        return null;
      }

      // Validación para el campo ServicioInternet
      if (ServicioInternet == null || ServicioInternet == undefined) {
        toast.error("¿Cuenta con servicio de internet en casa?: Campo obligatorio *");
        isvalid_setServicioInternet(true);
        return null;
      }
      if (ServicioInternet == "1" && !ServicioInternetCual) {
        toast.error("¿Cuál? (Internet): Campo obligatorio *");
        isvalid_setServicioInternetCual(true);
        return null;
      }

      // Validación para el campo Computadora
      if (Computadora == null || Computadora == undefined) {
        toast.error("¿Cuenta con computadora, tablet o celular?: Campo obligatorio *");
        isvalid_setComputadora(true);
        return null;
      }
      if (Computadora == "1" && !ComputadoraCual) {
        toast.error("¿Cuál? (Dispositivo): Campo obligatorio *");
        isvalid_setComputadoraCual(true);
        return null;
      }

      // Validación para el campo PlataformaVideo
      if (PlataformaVideo == null || PlataformaVideo == undefined) {
        toast.error(
          "¿Han utilizado alguna plataforma para video llamadas por internet?: Campo obligatorio *"
        );
        isvalid_setPlataformaVideo(true);
        return null;
      }
      if (PlataformaVideo == "1" && !PlataformaVideoCual) {
        toast.error("¿Cuál? (Plataforma de videollamada): Campo obligatorio *");
        isvalid_setPlataformaVideoCual(true);
        return null;
      }

      const datosServiciosAcceso = {
        aplicadoOtroPrograma: AplicadoOtroPrograma,
        aplicadoOtroProgramaCual: AplicadoOtroProgramaCual,
        rechazadoPrograma: RechazadoPrograma,
        rechazadoProgramaCual: RechazadoProgramaCual,
        evalOtroEspecialista: EvalOtroEspecialista,
        evalOtroEspecialistaCual: EvalOtroEspecialistaCual,
        evaluadoOdontologia: EvaluadoOdontologia,
        evaluadoOdontologiaDr: EvaluadoOdontologiaDr,
        servicioInternet: ServicioInternet,
        servicioInternetCual: ServicioInternetCual,
        computadora: Computadora,
        computadoraCual: ComputadoraCual,
        plataformaVideo: PlataformaVideo,
        plataformaVideoCual: PlataformaVideoCual,
      };
      Next(datosServiciosAcceso);
      return datosServiciosAcceso;
    };

    //Métodos para guardar los datos editados:
    useImperativeHandle(ref, () => ({
      ejecutarNext: () => {
        return ValidaForm();
      },
    }));

    const handleBack = () => {
      const data = {
        aplicadoOtroPrograma: AplicadoOtroPrograma,
        aplicadoOtroProgramaCual: AplicadoOtroProgramaCual,
        rechazadoPrograma: RechazadoPrograma,
        rechazadoProgramaCual: RechazadoProgramaCual,
        evalOtroEspecialista: EvalOtroEspecialista,
        evalOtroEspecialistaCual: EvalOtroEspecialistaCual,
        evaluadoOdontologia: EvaluadoOdontologia,
        evaluadoOdontologiaDr: EvaluadoOdontologiaDr,
        servicioInternet: ServicioInternet,
        servicioInternetCual: ServicioInternetCual,
        computadora: Computadora,
        computadoraCual: ComputadoraCual,
        plataformaVideo: PlataformaVideo,
        plataformaVideoCual: PlataformaVideoCual,
      };

      Back(data);
    };

    return (
      <>
        {/* Idioma de la Madre */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Ha aplicado a algún otro programa de implantes cocleares?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="AplicadoOtroPrograma"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == AplicadoOtroPrograma) || null
                  }
                  onChange={(event, newValue) => {
                    setAplicadoOtroPrograma(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setAplicadoOtroProgramaCual(true);
                    } else {
                      isvalid_setAplicadoOtroProgramaCual(false);
                      setAplicadoOtroProgramaCual("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      disabled={desactivar}
                      error={isvalid_AplicadoOtroPrograma}
                      helperText={isvalid_AplicadoOtroPrograma ? "Campo obligatorio *" : ""}
                      onFocus={() => isvalid_setAplicadoOtroPrograma(false)}
                      onBlur={() => {
                        if (AplicadoOtroPrograma == null) isvalid_setAplicadoOtroPrograma(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  variant="outlined"
                  disabled={desactivar}
                  label="¿A cuál?"
                  autoComplete="off"
                  value={AplicadoOtroProgramaCual}
                  error={isvalid_AplicadoOtroProgramaCual}
                  helperText={isvalid_AplicadoOtroProgramaCual ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setAplicadoOtroProgramaCual(false);
                    if (AplicadoOtroPrograma == null) {
                      isvalid_setAplicadoOtroPrograma(true);
                    }
                  }}
                  onChange={(e) => {
                    if (AplicadoOtroPrograma != null && AplicadoOtroPrograma == "1") {
                      setAplicadoOtroProgramaCual(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !AplicadoOtroProgramaCual &&
                      AplicadoOtroPrograma != null &&
                      AplicadoOtroPrograma == "1"
                    ) {
                      isvalid_setAplicadoOtroProgramaCual(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          {/* ¿Lo han rechazado de algún otro programa de implante coclear? */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Lo han rechazado de algún otro programa de implante coclear?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="RechazadoPrograma"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == RechazadoPrograma) || null
                  }
                  onChange={(event, newValue) => {
                    setRechazadoPrograma(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setRechazadoProgramaCual(true);
                    } else {
                      isvalid_setRechazadoProgramaCual(false);
                      setRechazadoProgramaCual("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      disabled={desactivar}
                      error={isvalid_RechazadoPrograma}
                      helperText={isvalid_RechazadoPrograma ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setRechazadoPrograma(false);
                        if (AplicadoOtroPrograma == null) {
                          isvalid_setAplicadoOtroPrograma(true);
                        }
                        if (!AplicadoOtroProgramaCual && AplicadoOtroPrograma == 1) {
                          isvalid_setAplicadoOtroProgramaCual(true);
                        }
                      }}
                      onBlur={() => {
                        if (RechazadoPrograma == null) isvalid_setRechazadoPrograma(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  variant="outlined"
                  disabled={desactivar}
                  label="¿De cuál?"
                  autoComplete="off"
                  value={RechazadoProgramaCual}
                  error={isvalid_RechazadoProgramaCual}
                  helperText={isvalid_RechazadoProgramaCual ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setRechazadoProgramaCual(false);
                    if (AplicadoOtroPrograma == null) {
                      isvalid_setAplicadoOtroPrograma(true);
                    }
                    if (!AplicadoOtroProgramaCual && AplicadoOtroPrograma == 1) {
                      isvalid_setAplicadoOtroProgramaCual(true);
                    }
                    if (RechazadoPrograma == null) {
                      isvalid_setRechazadoPrograma(true);
                    }
                  }}
                  onChange={(e) => {
                    if (RechazadoPrograma != null && RechazadoPrograma == "1") {
                      setRechazadoProgramaCual(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !RechazadoProgramaCual &&
                      RechazadoPrograma != null &&
                      RechazadoPrograma == "1"
                    ) {
                      isvalid_setRechazadoProgramaCual(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* ¿Ha sido evaluado por algún otro especialista? */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Ha sido evaluado por algún otro especialista?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="EvalOtroEspecialista"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == EvalOtroEspecialista) || null
                  }
                  onChange={(event, newValue) => {
                    setEvalOtroEspecialista(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setEvalOtroEspecialistaCual(true);
                    } else {
                      isvalid_setEvalOtroEspecialistaCual(false);
                      setEvalOtroEspecialistaCual("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      disabled={desactivar}
                      error={isvalid_EvalOtroEspecialista}
                      helperText={isvalid_EvalOtroEspecialista ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setEvalOtroEspecialista(false);
                        if (AplicadoOtroPrograma == null) {
                          isvalid_setAplicadoOtroPrograma(true);
                        }
                        if (!AplicadoOtroProgramaCual && AplicadoOtroPrograma == 1) {
                          isvalid_setAplicadoOtroProgramaCual(true);
                        }
                        if (RechazadoPrograma == null) {
                          isvalid_setRechazadoPrograma(true);
                        }
                        if (!RechazadoProgramaCual && RechazadoPrograma == 1) {
                          isvalid_setRechazadoProgramaCual(true);
                        }
                      }}
                      onBlur={() => {
                        if (EvalOtroEspecialista == null) isvalid_setEvalOtroEspecialista(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  variant="outlined"
                  disabled={desactivar}
                  label="¿Cuál? ¿Motivo?"
                  autoComplete="off"
                  value={EvalOtroEspecialistaCual}
                  error={isvalid_EvalOtroEspecialistaCual}
                  helperText={isvalid_EvalOtroEspecialistaCual ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setEvalOtroEspecialistaCual(false);
                    if (AplicadoOtroPrograma == null) {
                      isvalid_setAplicadoOtroPrograma(true);
                    }
                    if (!AplicadoOtroProgramaCual && AplicadoOtroPrograma == 1) {
                      isvalid_setAplicadoOtroProgramaCual(true);
                    }
                    if (RechazadoPrograma == null) {
                      isvalid_setRechazadoPrograma(true);
                    }
                    if (!RechazadoProgramaCual && RechazadoPrograma == 1) {
                      isvalid_setRechazadoProgramaCual(true);
                    }
                    if (EvalOtroEspecialista == null) {
                      isvalid_setEvalOtroEspecialista(true);
                    }
                  }}
                  onChange={(e) => {
                    if (EvalOtroEspecialista != null && EvalOtroEspecialista == "1") {
                      setEvalOtroEspecialistaCual(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !EvalOtroEspecialistaCual &&
                      EvalOtroEspecialista != null &&
                      EvalOtroEspecialista == "1"
                    ) {
                      isvalid_setEvalOtroEspecialistaCual(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* ¿Ha sido evaluado por odontología? */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Ha sido evaluado por odontología?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="EvaluadoOdontologia"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == EvaluadoOdontologia) || null
                  }
                  onChange={(event, newValue) => {
                    setEvaluadoOdontologia(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setEvaluadoOdontologiaDr(true);
                    } else {
                      isvalid_setEvaluadoOdontologiaDr(false);
                      setEvaluadoOdontologiaDr("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      disabled={desactivar}
                      error={isvalid_EvaluadoOdontologia}
                      helperText={isvalid_EvaluadoOdontologia ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setEvaluadoOdontologia(false);
                        if (AplicadoOtroPrograma == null) {
                          isvalid_setAplicadoOtroPrograma(true);
                        }
                        if (!AplicadoOtroProgramaCual && AplicadoOtroPrograma == 1) {
                          isvalid_setAplicadoOtroProgramaCual(true);
                        }
                        if (RechazadoPrograma == null) {
                          isvalid_setRechazadoPrograma(true);
                        }
                        if (!RechazadoProgramaCual && RechazadoPrograma == 1) {
                          isvalid_setRechazadoProgramaCual(true);
                        }
                        if (EvalOtroEspecialista == null) {
                          isvalid_setEvalOtroEspecialista(true);
                        }
                        if (!EvalOtroEspecialistaCual && EvalOtroEspecialista == 1) {
                          isvalid_setEvalOtroEspecialistaCual(true);
                        }
                      }}
                      onBlur={() => {
                        if (EvaluadoOdontologia == null) isvalid_setEvaluadoOdontologia(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  variant="outlined"
                  disabled={desactivar}
                  label="Nombre del doctor"
                  autoComplete="off"
                  value={EvaluadoOdontologiaDr}
                  error={isvalid_EvaluadoOdontologiaDr}
                  helperText={isvalid_EvaluadoOdontologiaDr ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setEvaluadoOdontologiaDr(false);
                    if (AplicadoOtroPrograma == null) {
                      isvalid_setAplicadoOtroPrograma(true);
                    }
                    if (!AplicadoOtroProgramaCual && AplicadoOtroPrograma == 1) {
                      isvalid_setAplicadoOtroProgramaCual(true);
                    }
                    if (RechazadoPrograma == null) {
                      isvalid_setRechazadoPrograma(true);
                    }
                    if (!RechazadoProgramaCual && RechazadoPrograma == 1) {
                      isvalid_setRechazadoProgramaCual(true);
                    }
                    if (EvalOtroEspecialista == null) {
                      isvalid_setEvalOtroEspecialista(true);
                    }
                    if (!EvalOtroEspecialistaCual && EvalOtroEspecialista == 1) {
                      isvalid_setEvalOtroEspecialistaCual(true);
                    }
                    if (EvaluadoOdontologia == null) {
                      isvalid_setEvaluadoOdontologia(true);
                    }
                  }}
                  onChange={(e) => {
                    if (EvaluadoOdontologia != null && EvaluadoOdontologia == "1") {
                      setEvaluadoOdontologiaDr(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !EvaluadoOdontologiaDr &&
                      EvaluadoOdontologia != null &&
                      EvaluadoOdontologia == "1"
                    ) {
                      isvalid_setEvaluadoOdontologiaDr(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* ¿Cuenta con servicio de internet en casa? */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Cuenta con servicio de internet en casa?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="ServicioInternet"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == ServicioInternet) || null
                  }
                  onChange={(event, newValue) => {
                    setServicioInternet(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setServicioInternetCual(true);
                    } else {
                      isvalid_setServicioInternetCual(false);
                      setServicioInternetCual("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      disabled={desactivar}
                      error={isvalid_ServicioInternet}
                      helperText={isvalid_ServicioInternet ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setServicioInternet(false);
                        if (AplicadoOtroPrograma == null) {
                          isvalid_setAplicadoOtroPrograma(true);
                        }
                        if (!AplicadoOtroProgramaCual && AplicadoOtroPrograma == 1) {
                          isvalid_setAplicadoOtroProgramaCual(true);
                        }
                        if (RechazadoPrograma == null) {
                          isvalid_setRechazadoPrograma(true);
                        }
                        if (!RechazadoProgramaCual && RechazadoPrograma == 1) {
                          isvalid_setRechazadoProgramaCual(true);
                        }
                        if (EvalOtroEspecialista == null) {
                          isvalid_setEvalOtroEspecialista(true);
                        }
                        if (!EvalOtroEspecialistaCual && EvalOtroEspecialista == 1) {
                          isvalid_setEvalOtroEspecialistaCual(true);
                        }
                        if (EvaluadoOdontologia == null) {
                          isvalid_setEvaluadoOdontologia(true);
                        }
                        if (!EvaluadoOdontologiaDr && EvaluadoOdontologia == 1) {
                          isvalid_setEvaluadoOdontologiaDr(true);
                        }
                      }}
                      onBlur={() => {
                        if (ServicioInternet == null) isvalid_setServicioInternet(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  variant="outlined"
                  disabled={desactivar}
                  label="¿Cuál?"
                  autoComplete="off"
                  value={ServicioInternetCual}
                  error={isvalid_ServicioInternetCual}
                  helperText={isvalid_ServicioInternetCual ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setServicioInternetCual(false);
                    if (AplicadoOtroPrograma == null) {
                      isvalid_setAplicadoOtroPrograma(true);
                    }
                    if (!AplicadoOtroProgramaCual && AplicadoOtroPrograma == 1) {
                      isvalid_setAplicadoOtroProgramaCual(true);
                    }
                    if (RechazadoPrograma == null) {
                      isvalid_setRechazadoPrograma(true);
                    }
                    if (!RechazadoProgramaCual && RechazadoPrograma == 1) {
                      isvalid_setRechazadoProgramaCual(true);
                    }
                    if (EvalOtroEspecialista == null) {
                      isvalid_setEvalOtroEspecialista(true);
                    }
                    if (!EvalOtroEspecialistaCual && EvalOtroEspecialista == 1) {
                      isvalid_setEvalOtroEspecialistaCual(true);
                    }
                    if (EvaluadoOdontologia == null) {
                      isvalid_setEvaluadoOdontologia(true);
                    }
                    if (!EvaluadoOdontologiaDr && EvaluadoOdontologia == 1) {
                      isvalid_setEvaluadoOdontologiaDr(true);
                    }
                    if (ServicioInternet == null) {
                      isvalid_setServicioInternet(true);
                    }
                  }}
                  onChange={(e) => {
                    if (ServicioInternet != null && ServicioInternet == "1") {
                      setServicioInternetCual(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !ServicioInternetCual &&
                      ServicioInternet != null &&
                      ServicioInternet == "1"
                    ) {
                      isvalid_setServicioInternetCual(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* ¿Cuenta con computadora, tablet o celular? */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Cuenta con computadora, tablet o celular?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="Computadora"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == Computadora) || null
                  }
                  onChange={(event, newValue) => {
                    setComputadora(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setComputadoraCual(true);
                    } else {
                      isvalid_setComputadoraCual(false);
                      setComputadoraCual("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      disabled={desactivar}
                      error={isvalid_Computadora}
                      helperText={isvalid_Computadora ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setComputadora(false);
                        if (AplicadoOtroPrograma == null) {
                          isvalid_setAplicadoOtroPrograma(true);
                        }
                        if (!AplicadoOtroProgramaCual && AplicadoOtroPrograma == 1) {
                          isvalid_setAplicadoOtroProgramaCual(true);
                        }
                        if (RechazadoPrograma == null) {
                          isvalid_setRechazadoPrograma(true);
                        }
                        if (!RechazadoProgramaCual && RechazadoPrograma == 1) {
                          isvalid_setRechazadoProgramaCual(true);
                        }
                        if (EvalOtroEspecialista == null) {
                          isvalid_setEvalOtroEspecialista(true);
                        }
                        if (!EvalOtroEspecialistaCual && EvalOtroEspecialista == 1) {
                          isvalid_setEvalOtroEspecialistaCual(true);
                        }
                        if (EvaluadoOdontologia == null) {
                          isvalid_setEvaluadoOdontologia(true);
                        }
                        if (!EvaluadoOdontologiaDr && EvaluadoOdontologia == 1) {
                          isvalid_setEvaluadoOdontologiaDr(true);
                        }
                        if (ServicioInternet == null) {
                          isvalid_setServicioInternet(true);
                        }
                        if (!ServicioInternetCual && ServicioInternet == 1) {
                          isvalid_setServicioInternetCual(true);
                        }
                      }}
                      onBlur={() => {
                        if (Computadora == null) isvalid_setComputadora(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  variant="outlined"
                  disabled={desactivar}
                  label="¿Cuál?"
                  autoComplete="off"
                  value={ComputadoraCual}
                  error={isvalid_ComputadoraCual}
                  helperText={isvalid_ComputadoraCual ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setComputadoraCual(false);
                    if (AplicadoOtroPrograma == null) {
                      isvalid_setAplicadoOtroPrograma(true);
                    }
                    if (!AplicadoOtroProgramaCual && AplicadoOtroPrograma == 1) {
                      isvalid_setAplicadoOtroProgramaCual(true);
                    }
                    if (RechazadoPrograma == null) {
                      isvalid_setRechazadoPrograma(true);
                    }
                    if (!RechazadoProgramaCual && RechazadoPrograma == 1) {
                      isvalid_setRechazadoProgramaCual(true);
                    }
                    if (EvalOtroEspecialista == null) {
                      isvalid_setEvalOtroEspecialista(true);
                    }
                    if (!EvalOtroEspecialistaCual && EvalOtroEspecialista == 1) {
                      isvalid_setEvalOtroEspecialistaCual(true);
                    }
                    if (EvaluadoOdontologia == null) {
                      isvalid_setEvaluadoOdontologia(true);
                    }
                    if (!EvaluadoOdontologiaDr && EvaluadoOdontologia == 1) {
                      isvalid_setEvaluadoOdontologiaDr(true);
                    }
                    if (ServicioInternet == null) {
                      isvalid_setServicioInternet(true);
                    }
                    if (!ServicioInternetCual && ServicioInternet == 1) {
                      isvalid_setServicioInternetCual(true);
                    }
                    if (Computadora == null) {
                      isvalid_setComputadora(true);
                    }
                  }}
                  onChange={(e) => {
                    if (Computadora != null && Computadora == "1") {
                      setComputadoraCual(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (!ComputadoraCual && Computadora != null && Computadora == "1") {
                      isvalid_setComputadoraCual(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* ¿Han utilizado alguna plataforma para video llamadas por internet? */}
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Han utilizado alguna plataforma para video llamadas por internet?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="PlataformaVideo"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == PlataformaVideo) || null
                  }
                  onChange={(event, newValue) => {
                    setPlataformaVideo(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setPlataformaVideoCual(true);
                    } else {
                      isvalid_setPlataformaVideoCual(false);
                      setPlataformaVideoCual("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      disabled={desactivar}
                      error={isvalid_PlataformaVideo}
                      helperText={isvalid_PlataformaVideo ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setPlataformaVideo(false);
                        if (AplicadoOtroPrograma == null) {
                          isvalid_setAplicadoOtroPrograma(true);
                        }
                        if (!AplicadoOtroProgramaCual && AplicadoOtroPrograma == 1) {
                          isvalid_setAplicadoOtroProgramaCual(true);
                        }
                        if (RechazadoPrograma == null) {
                          isvalid_setRechazadoPrograma(true);
                        }
                        if (!RechazadoProgramaCual && RechazadoPrograma == 1) {
                          isvalid_setRechazadoProgramaCual(true);
                        }
                        if (EvalOtroEspecialista == null) {
                          isvalid_setEvalOtroEspecialista(true);
                        }
                        if (!EvalOtroEspecialistaCual && EvalOtroEspecialista == 1) {
                          isvalid_setEvalOtroEspecialistaCual(true);
                        }
                        if (EvaluadoOdontologia == null) {
                          isvalid_setEvaluadoOdontologia(true);
                        }
                        if (!EvaluadoOdontologiaDr && EvaluadoOdontologia == 1) {
                          isvalid_setEvaluadoOdontologiaDr(true);
                        }
                        if (ServicioInternet == null) {
                          isvalid_setServicioInternet(true);
                        }
                        if (!ServicioInternetCual && ServicioInternet == 1) {
                          isvalid_setServicioInternetCual(true);
                        }
                        if (Computadora == null) {
                          isvalid_setComputadora(true);
                        }
                        if (!ComputadoraCual && Computadora == 1) {
                          isvalid_setComputadoraCual(true);
                        }
                      }}
                      onBlur={() => {
                        if (PlataformaVideo == null) isvalid_setPlataformaVideo(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  variant="outlined"
                  disabled={desactivar}
                  label="¿Cuál?"
                  autoComplete="off"
                  value={PlataformaVideoCual}
                  error={isvalid_PlataformaVideoCual}
                  helperText={isvalid_PlataformaVideoCual ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setPlataformaVideoCual(false);
                    if (AplicadoOtroPrograma == null) {
                      isvalid_setAplicadoOtroPrograma(true);
                    }
                    if (!AplicadoOtroProgramaCual && AplicadoOtroPrograma == 1) {
                      isvalid_setAplicadoOtroProgramaCual(true);
                    }
                    if (RechazadoPrograma == null) {
                      isvalid_setRechazadoPrograma(true);
                    }
                    if (!RechazadoProgramaCual && RechazadoPrograma == 1) {
                      isvalid_setRechazadoProgramaCual(true);
                    }
                    if (EvalOtroEspecialista == null) {
                      isvalid_setEvalOtroEspecialista(true);
                    }
                    if (!EvalOtroEspecialistaCual && EvalOtroEspecialista == 1) {
                      isvalid_setEvalOtroEspecialistaCual(true);
                    }
                    if (EvaluadoOdontologia == null) {
                      isvalid_setEvaluadoOdontologia(true);
                    }
                    if (!EvaluadoOdontologiaDr && EvaluadoOdontologia == 1) {
                      isvalid_setEvaluadoOdontologiaDr(true);
                    }
                    if (ServicioInternet == null) {
                      isvalid_setServicioInternet(true);
                    }
                    if (!ServicioInternetCual && ServicioInternet == 1) {
                      isvalid_setServicioInternetCual(true);
                    }
                    if (Computadora == null) {
                      isvalid_setComputadora(true);
                    }
                    if (!ComputadoraCual && Computadora == 1) {
                      isvalid_setComputadoraCual(true);
                    }
                    if (PlataformaVideo == null) {
                      isvalid_setPlataformaVideo(true);
                    }
                  }}
                  onChange={(e) => {
                    if (PlataformaVideo != null && PlataformaVideo == "1") {
                      setPlataformaVideoCual(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (!PlataformaVideoCual && PlataformaVideo != null && PlataformaVideo == "1") {
                      isvalid_setPlataformaVideoCual(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {vista === "visualizar" ? null : (
          <MDBox textAlign="right">
            <Button
              variant="contained"
              onClick={() => ValidaForm()}
              sx={{ mt: 1, mr: 1 }}
              size="small"
              color="primary"
            >
              {"Continuar"}
            </Button>
            <Button
              variant="contained"
              disabled={false}
              onClick={() => handleBack()}
              sx={{ mt: 1, mr: 1 }}
              color="secondary"
              size="small"
            >
              Volver
            </Button>
          </MDBox>
        )}
      </>
    );
  }
);
export default DatosAdicionales1;
